<template>
    <footer class="bg-black p3 col-12 border-box md-flex justify-center flex-wrap">
        <div class="py1">
            <router-link to="/" class="white sm-m2">Home</router-link>
        </div>
        <div class="py1">
            <a href="https://nachtschicht-schortens.de/" class="white sm-m2">Nachtschicht</a>
        </div>
        <div class="py1">
            <a href="https://nachtschicht-schortens.de/?page_id=1334" class="white sm-m2">Impressum</a>
        </div>
        <div class="py1">
            <a href="https://nachtschicht-schortens.de/?page_id=1338" class="white sm-m2">Datenschutz</a>
        </div>
    </footer>
</template>
<script>
export default {
    name: "FooterComp",
    props: {

    }
}
</script>
<style>

</style>